module.exports = __webpack_public_path__ + "img/sph.1344cc51.jpg";